
<div *ngIf="loaderType === 'default'" class="">
  <!-- <div class="ldio-b2b0m9u27rm">
    <div></div>
    <div>
      <div></div>
    </div>
  </div> -->
  <div class="loading-container">
    <svg
  width="200"
  height="200"
  viewBox="0 0 200 200"
  xmlns="http://www.w3.org/2000/svg"
>
  <!-- Outer Circle -->
  <circle
    cx="100"
    cy="100"
    r="72"
    fill="none"
    stroke="#E8E8E8"
    stroke-width="6"
  />

  <!-- Animated Progress Arc -->
  <g transform-origin="100 100">
    <circle
      cx="100"
      cy="100"
      r="72"
      fill="none"
      stroke="#57B89A"
      stroke-width="6"
      stroke-linecap="round"
      stroke-dasharray="90 362"
      transform="rotate(-90 100 100)"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="-90 100 100"
        to="270 100 100"
        dur="1.5s"
        repeatCount="indefinite"
      />
    </circle>
  </g>

  <!-- Center Circle -->
  <circle
    cx="100"
    cy="100"
    r="42"
    fill="#57B89A"
  />

  <!-- Menu Icon -->
  <g stroke="#FFFFFF" stroke-width="5" stroke-linecap="round">
    <line x1="82" y1="88" x2="118" y2="88">
      <animate
        attributeName="opacity"
        values="1;0.6;1"
        dur="1.2s"
        repeatCount="indefinite"
      />
    </line>

    <line x1="82" y1="100" x2="118" y2="100">
      <animate
        attributeName="opacity"
        values="0.6;1;0.6"
        dur="1.2s"
        repeatCount="indefinite"
      />
    </line>

    <line x1="82" y1="112" x2="118" y2="112">
      <animate
        attributeName="opacity"
        values="1;0.6;1"
        dur="1.2s"
        begin="0.3s"
        repeatCount="indefinite"
      />
    </line>
  </g>
</svg>
<p class="loading-text">Loading your data...</p>
  </div>
</div>

<div *ngIf="loaderType === 'flight'" class="flight">

  <div class="card p-4 skeleton mb-4" *ngFor="let item of [1,2,3,4,5,6,7,8]" >
    <div class="d-flex">
      <div class="skeleton-box logo"></div>
      <div class="ms-3 flex-grow-1">
        <div class="skeleton-box title mb-2"></div>
        <div class="skeleton-box subtitle mb-2"></div>
        <div class="skeleton-box subtitle mb-2"></div>
      </div>
      <div class="ms-auto text-end">
        <div class="skeleton-box price mb-2"></div>
        <div class="skeleton-box subtitle"></div>
      </div>
    </div>
    <div class="skeleton-box timeline mt-4"></div>
    <div class="d-flex justify-content-between mt-3">
      <div class="skeleton-box small-text"></div>
      <div class="skeleton-box small-text"></div>
      <div class="skeleton-box small-text"></div>
    </div>
  </div>
</div>
<div *ngIf="loaderType === 'accomodation'" class="accomodation">
  <div class="row">

    <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4" *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]">
      <div class="card p-3 skeleton">
        <div class="skeleton-box image mb-3"></div>
        <div class="skeleton-box badge mb-3"></div>
        <div class="skeleton-box price mb-2"></div>
        <div class="skeleton-box title mb-2"></div>
        <div class="skeleton-box subtitle mb-3"></div>
        <div class="d-flex align-items-center mb-2">
          <div class="skeleton-box icon me-2"></div>
          <div class="skeleton-box small-text me-3"></div>
          <div class="skeleton-box icon me-2"></div>
          <div class="skeleton-box small-text"></div>
        </div>
      </div>
    </div>
  </div>
</div>

